import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { PulseLoader } from "react-spinners";
import { GetDynamicFieldRepositoryForTaskType } from "../../../../../../services/api/dynamic-fields-api";
import { FluentTooltip } from "../../../../../../components/FluentUI/Fluent-Tooltip";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import { FluentInput } from "../../../../../../components/FluentUI/Fluent-Input";
import { ModifyFormRightPanelItem } from "./modify-form-right-panel-item";
import "./common-components.scss";

export const ModifyFormRightPanel = ({ subForms, AddFieldToSection, showURLField = true }) => {
  const [fields, setFields] = useState({
    allFields: [],
    filteredFields: [],
    isLoading: true,
  });

  useEffect(() => {
    const GetFieldRepository = async () => {
      try {
        let res = await GetDynamicFieldRepositoryForTaskType();
        if (res.status === 200) {
          const allFields = showURLField 
            ? res.data 
            : res.data.filter(field => field.FieldType !== "URL");
          
          setFields((prev) => ({
            ...prev,
            allFields: allFields,
            filteredFields: allFields,
            isLoading: false,
          }));
        }
      } catch (err) {
        console.log("Error [GetDynamicFieldRepositoryForTaskType] => ", err);
      }
    };
    GetFieldRepository();
  }, [showURLField]);

  const SearchField = ({ target }) => {
    const filteredFields = fields.allFields.filter((field) =>
      field.Label.toLowerCase().includes(target.value.toLowerCase())
    );
    setFields((prev) => ({
      ...prev,
      filteredFields: filteredFields,
    }));
  };

  return (
    <div className="task-type-right-panel">
      {fields.isLoading ? (
        <div className="pulse-loader" data-testid="loading-spinner">
          <PulseLoader></PulseLoader>
        </div>
      ) : (
        <>
          <div className="task-type-right-panel-head">
            Fields
            <sup>
              <FluentTooltip
                target={
                  <span>
                    <FluentUiIcon
                      name={"InfoRegular"}
                      color={"#424242"}
                      size={16}
                    />
                  </span>
                }
                text="Add a Field created in Field Repository or other Task Types to one of the sections on the left to create a custom field for this Task Type."
              ></FluentTooltip>
            </sup>
          </div>
          <div className="task-type-right-panel-search">
            <FluentInput
              placeholder={"Type to search all Fields"}
              label={"Search all existing Fields"}
              contentAfter={
                <FluentUiIcon
                  name={"SearchRegular"}
                  color={"#616161"}
                  size={18}
                />
              }
              onChange={SearchField}
            ></FluentInput>
          </div>
          <div className="task-type-right-panel-fields">
            <div className="task-type-right-panel-fields-head">
              Fields recently used
            </div>
            {fields.filteredFields.map((field) => (
              <ModifyFormRightPanelItem
                key={field.DisplayOrder}
                field={field}
                subForms={subForms}
                AddFieldToSection={AddFieldToSection}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

ModifyFormRightPanel.propTypes = {
  subForms: PropTypes.array,
  AddFieldToSection: PropTypes.func,
  showURLField: PropTypes.bool,
};
